import { render, staticRenderFns } from "./modifycheck.vue?vue&type=template&id=4e28df16&"
import script from "./modifycheck.vue?vue&type=script&lang=js&"
export * from "./modifycheck.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e28df16')) {
      api.createRecord('4e28df16', component.options)
    } else {
      api.reload('4e28df16', component.options)
    }
    module.hot.accept("./modifycheck.vue?vue&type=template&id=4e28df16&", function () {
      api.rerender('4e28df16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/check/components/modifycheck.vue"
export default component.exports